import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=4aac4d18"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=4aac4d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports